import {
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Text,
  Image,
  Link,
  Button,
  Avatar,
} from '@chakra-ui/react'
import { formatUrl } from '@/components/video-page/utils/formatOptions'
import {
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  EmailShareButton,
  LinkedinShareButton,
} from 'react-share'
import { Icons } from '@/components/icons'
import { toast } from 'sonner'
import { getInitials } from '../avatar'

interface videoDataInterface {
  thumbnailUrl?: string
  videoDuration: string
  watchTime: string
  title: string
  creatorName: string
  eventId?: string
  themeColor?: string
  encryptVideoUrl?: string
}

export default function ShareChannel({
  isOpen,
  onClose,
  // link,
  name,
  link,
  imageUrl,
  themeColor,
}: {
  isOpen: boolean
  onClose: () => void
  // link?: string
  name: string
  link: string
  imageUrl?: string
  themeColor?: string
}) {
  const copyToClipboardLink = () => {
    navigator.clipboard.writeText(link)
    toast.success('Copied to clipboard')
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={'sm'} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Share this channel</ModalHeader>
        <ModalCloseButton mt={2} />
        <hr />

        <>
          <ModalBody mb={5} mt={2}>
            <Flex mb={5} justify={'flex-start'} gap={'1em'} align={'center'}>
              <Box>
                <Avatar
                  name={name}
                  src={formatUrl(imageUrl || '')}
                  getInitials={getInitials}
                  h="60px"
                  w="60px"
                  bg={themeColor}
                  color="white"
                />
              </Box>

              <Text
                noOfLines={1}
                fontWeight={600}
                fontSize={24}
                color={'#3E3E3E'}
              >
                {name || ''}
              </Text>
            </Flex>
            <Flex
              mt={5}
              bg={'gray.100'}
              p={3}
              alignItems={'center'}
              rounded={'md'}
              overflow={'hidden'}
            >
              <Box flex={1} overflow="hidden">
                <Text fontWeight={500} fontSize={15}>
                  Channel link
                </Text>
                <Flex columnGap={2}>
                  <Link
                    fontWeight={500}
                    fontSize={15}
                    color={'#318FD2'}
                    href={link}
                    target="_blank"
                    overflow="hidden"
                    textOverflow="ellipsis"
                    whiteSpace="nowrap"
                    display="block"
                    maxWidth={"87%"}
                  >
                    {link.startsWith('http') ? link.split('://')[1] : link}
                  </Link>
                  <Box className="cursor-pointer" onClick={copyToClipboardLink}>
                  <Image width={"25px"} ml={1} src={'/copy.svg'} alt="Copy" />
                  </Box>
                </Flex>
              </Box>
            </Flex>
            <Flex
              mt={3}
              bg={'gray.100'}
              p={3}
              justifyContent={'flex-start'}
              gap={4}
              alignItems={'center'}
              rounded={'md'}
            >
              <Text fontSize={15} fontWeight={500}>
                Share a link
              </Text>
              <FacebookShareButton url={link}>
                <Image
                  className="cursor-pointer"
                  boxSize={5}
                  src={'/socials/facebook.svg'}
                  alt="Copy"
                />
              </FacebookShareButton>
              <WhatsappShareButton url={link}>
                <Image
                  className="cursor-pointer"
                  boxSize={5}
                  src={'/socials/whatsapp.svg'}
                  alt="Copy"
                />
              </WhatsappShareButton>
              <TwitterShareButton url={link}>
                <Image boxSize={5} src={'/socials/twitter.svg'} alt="Copy" />
              </TwitterShareButton>
              <EmailShareButton url={link}>
                <Image boxSize={5} src={'/socials/email.svg'} alt="Copy" />
              </EmailShareButton>
              <LinkedinShareButton url={link}>
                <Image boxSize={5} src={'/socials/linkedin.svg'} alt="Copy" />
              </LinkedinShareButton>
            </Flex>

            {/* <Flex alignItems={'center'} mt={3} gap={1}>
              <Checkbox fontWeight={500}>Start video from</Checkbox>

              <Input
                type="text"
                variant={'unstyled'}
                color={'lyk-green'}
                border={'none'}
                height={5}
                textDecor={'underline'}
                fontWeight={700}
                flex={1}
                value={'1:00'}
              />
            </Flex> */}
          </ModalBody>
        </>
      </ModalContent>
    </Modal>
  )
}
